import L from 'leaflet';

export const MACHINE_ICON_MAP: Record<string, string> = {
  "contrabalançada": "/icons/frontal.png",
  "contrabalançada combustão": "/icons/frontal.png",
  "contrabalançada diesel": "/icons/frontal.png",
  "frontal": "/icons/frontal.png",
  "retrátil": "/icons/retratil.png",
  "transpaleteira": "/icons/transpaleteira.png",
  "patolada": "/icons/patolada.png",
  "rebocador": "/icons/rebocador.png",
  "rebocador combustão": "/icons/rebocador.png",
  "rebocador diesel": "/icons/rebocador.png",
  "articulada": "/icons/articulada.png",
  "selecionadora vertical": "/icons/selecionadoraVertical.png",
  "selecionadora horizontal": "/icons/selecionadoraHorizontal.png",
};



export const STATE_COLORS: Record<string, string> = {
  "Desligado": "#2196F3",
  "Login": "#e221f3ff",
  "Checklist": "#FFB300",   // amarelo
  "Bloqueada": "#F44336",   // vermelho
  "Operando": "#4CAF50",   // verde
  "Bloqueado Remoto": "#D32F2F",   // vermelho escuro
  "Atualizando": "#673AB7",   // roxo
  "Manutenção": "#7b102a",   // vinho Automni
};

export function createMachineIcon(color: string, iconUrl: string) {
  return L.divIcon({
    className: "",
    html: `
      <div class="pin-wrapper">
        <div
          class="pin-circle"
          style="background-color: ${color};"
        ></div>

        <div
          class="pin-tail"
          style="border-top: 12px solid ${color};"
        ></div>

        <img src="${iconUrl}" class="pin-icon" />
      </div>
    `,
    iconSize: [30, 30],
    iconAnchor: [0, 10],
    popupAnchor: [0, -25],
  });
}

export function normalizeName(name: string) {
  if (!name) return "";
  return name.toLowerCase().trim();
}

export function getMachineIcon(state: string, tipo: string) {
  const normalizedTipo = normalizeName(tipo);
  const iconUrl = MACHINE_ICON_MAP[normalizedTipo] || "/icons/frontal.png";
  return createMachineIcon(STATE_COLORS[state] ?? STATE_COLORS["Desligado"], iconUrl);
}
